import { addMeta, removeMeta } from './metadata-store';

export interface CapioEngage {
  addMeta(key: string, value: string): void;
  removeMeta(key: string): void;
}

export function createCapioEngage(): CapioEngage {
  return {
    addMeta,
    removeMeta,
  };
}

export function installCapioEngageOnWindow(): () => CapioEngage {
  const api = createCapioEngage();
  const capioEngage = (): CapioEngage => api;
  window.capioEngage = capioEngage;
  return capioEngage;
}

declare global {
  interface Window {
    capioEngage?: () => CapioEngage;
  }
}
